import { STOPLIGHT_COLORS } from '../../utils/DataFormatterUtils';
import { ENTITY_ADD_REQUEST_STATUSES } from '../../constants/EntityAddRequestStatuses';

const DRAFT_STEP = {
	displayName: 'Draft',
	name: ENTITY_ADD_REQUEST_STATUSES.draft,
	filter: { status: ENTITY_ADD_REQUEST_STATUSES.draft },
	icon: 'icons8-edit',
	iconStyle: { color: 'rgb(11, 28, 111)' },
};

const PENDING_REVIEW_STEP = {
	displayName: 'Pending',
	name: ENTITY_ADD_REQUEST_STATUSES.pending_review,
	filter: { status: ENTITY_ADD_REQUEST_STATUSES.pending_review },
	icon: 'icons8-time',
	iconStyle: { color: '#4a1e87' },
};

const APPROVED_STEP = {
	displayName: 'Approved',
	name: ENTITY_ADD_REQUEST_STATUSES.approved,
	filter: { status: ENTITY_ADD_REQUEST_STATUSES.approved },
	icon: 'icons8-approve',
	iconStyle: { color: STOPLIGHT_COLORS.pureGreen },
};

const REJECTED_STEP = {
	displayName: 'Rejected',
	name: ENTITY_ADD_REQUEST_STATUSES.rejected,
	filter: { status: ENTITY_ADD_REQUEST_STATUSES.rejected },
	icon: 'icons8-cancel',
	iconStyle: { color: STOPLIGHT_COLORS.pureRed },
};

// Requester sees their own requests including drafts.
export const REQUESTER_PIPELINE_FILTERS = [
	DRAFT_STEP,
	PENDING_REVIEW_STEP,
	APPROVED_STEP,
	REJECTED_STEP,
];

// Approvers act on submitted requests only — no drafts.
export const APPROVER_PIPELINE_FILTERS = [PENDING_REVIEW_STEP, APPROVED_STEP, REJECTED_STEP];
